import { Box, Button, Input, TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState } from 'src/store';
import {
  editBtnText,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnFontFamily,
  editBtnColor
} from 'src/store/modules/buttons';

import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';

import ChevronUp from 'src/components/Icon/ChevronUp';
import ChevronDown from 'src/components/Icon/ChevronDown';
import FontFamilyPicker from '../FontFamilyPicker';
import EditBtnBgColor from '../EditBtnBgColorRegurcy';

interface editBtnProps {
  type: string;
}
const useStyles = makeStyles(() => ({
  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  }
}));

const EditBtnFont: FC<editBtnProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );

  const handleBtnFontSize = f => {
    let newBtnFontSize = JSON.parse(JSON.stringify(btnFontSize));
    newBtnFontSize[type] = btnFontSize[type] + f;
    dispatch(editBtnFontSize(newBtnFontSize));
  };

  return (
    <div className={classes.bottomBtn}>
      <Box style={{ display: 'flex', gap: '1rem' }}>
        <Button
          className={classes.btnMinusPlus}
          disabled={btnFontSize[type] === 5 / 8}
          onClick={() => handleBtnFontSize(-1 / 16)}
        >
          <Minus stroke={btnFontSize[type] === 5 / 8 ? '#BDBDBD' : '#000'} />
        </Button>
        <Button
          className={classes.btnMinusPlus}
          disabled={btnFontSize[type] === 4}
          onClick={() => handleBtnFontSize(1 / 16)}
        >
          <Plus stroke={btnFontSize[type] === 4 ? '#BDBDBD' : '#000'} />
        </Button>
      </Box>

      <div className={classes.fontNumber}>{btnFontSize[type] * 16}</div>
    </div>
  );
};

export default EditBtnFont;
